import React from "react";
import { useMediaQuery } from "react-responsive";
import { Channel, GridItemProps, Program, useEpg } from "@nessprim/planby";
// Helpers
import { fetchResources } from "./helpers";

// Import theme
import { theme } from "./helpers/theme";

// Example of globalStyles
// const globalStyles = `
// @import url('https://fonts.googleapis.com/css2?family=Antonio:wght@400;500;600&display=swap');
// .planby {
//   font-family: "Antonio", system-ui, -apple-system,
//     /* Firefox supports this but not yet system-ui */ "Segoe UI", Roboto,
//     Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"; /* 2 */
// }
// `;

export function useApp() {
  const startDate = "2023-08-20T10:00:00";
  const endDate = "2023-08-20T16:00:00";

  const isMobileMax = useMediaQuery({
    query: "(max-width: 800px)",
  });
  const [channels, setChannels] = React.useState<Channel[]>([]);
  const [epg, setEpg] = React.useState<Program[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isSnap, setIsSnap] = React.useState<boolean>(false);

  const channelsData = React.useMemo(() => channels, [channels]);
  const epgData = React.useMemo(() => epg, [epg]);
  console.log("isSnap", isSnap);
  const snap = isSnap ? { snap: { x: 91.5 } } : {};
  const { getEpgProps, getLayoutProps, getLayoutData } = useEpg({
    channels: channelsData,
    epg: epgData,
    dayWidth: 2200,
    startDate,
    endDate,
    isVerticalMode: isMobileMax,
    sidebarWidth: isMobileMax ? 100 : 100,
    itemHeight: isMobileMax ? 300 : 90,
    channelMapKey: "id",
    programChannelMapKey: "trackId",
    isBaseTimeFormat: true,
    isResize: true,
    ...snap,
    overlap: {
      enabled: true,
      mode: "stack",
      layerOverlapLevel: 0.4,
    },
    dnd: { enabled: true, mode: "multi-rows" },
    grid: {
      enabled: true,
      onGridItemClick: (props: GridItemProps) => alert(JSON.stringify(props)),
      hoverHighlight: true,
    },
    theme,
  });

  const handleFetchResources = React.useCallback(async () => {
    setIsLoading(true);
    const { epg, channels } = (await fetchResources()) as {
      epg: Program[];
      channels: Channel[];
    };

    setEpg(epg);
    setChannels(channels);
    setIsLoading(false);
  }, []);

  const handleSetSnap = React.useCallback(() => setIsSnap((prev) => !prev), []);

  React.useEffect(() => {
    handleFetchResources();
  }, [handleFetchResources]);

  return {
    isLoading,
    getEpgProps,
    getLayoutProps,
    getLayoutData,
    setSnap: handleSetSnap,
  };
}
